import FinalizeOrder from './FinalizeOrder.component';

export default FinalizeOrder;
